import {ARTICLES_SORT} from '../../action-types';

export default sort => dispatch => dispatch({
	type: ARTICLES_SORT,
	sort
});
